document.addEventListener("DOMContentLoaded", function () {
  const trainer = document.querySelector("#espresso-trainer");

  if (!trainer) return;

  // Grinder
  const marker = trainer.querySelector(".grinder-marker");
  const grinderDial = trainer.querySelector(".grinder-dial");

  // Espresso machine
  const startButton = trainer.querySelector("#start-shot");
  const stopButton = trainer.querySelector("#stop-shot");

  const timeDisplay = trainer.querySelector("#shot-time");
  const weightDisplay = trainer.querySelector("#shot-weight");
  const lastShotDisplay = trainer.querySelector("#last-shot");

  const attemptDisplay =
  trainer.querySelector("#attempt-display");

  const espressoStream =
    trainer.querySelector("#espresso-stream");

  const espressoLiquid =
    trainer.querySelector("#espresso-liquid");

  const scaleDisplay =
    trainer.querySelector("#scale-display");

  // Target time buttons
  const targetButtons = trainer.querySelectorAll(".target-options button");

  // New calibration
  const newCalibrationButton =
    trainer.querySelector("#new-calibration");

  let grinderSetting = 50;

  // Hidden ideal grinder setting
  let idealGrinderSetting = randomNumber(33, 67);

  let targetMin = 25;
  let targetMax = 29;

  let shotRunning = false;
  let shotStartTime = 0;
  let animationFrame;

  let currentTime = 0;
  let currentWeight = 0;

  let attempts = 0;

  function randomNumber(min, max) {
    return Math.random() * (max - min) + min;
  }

  function updateGrinder() {
    const minAngle = -130;
    const maxAngle = 130;

    const angle =
      minAngle +
      (grinderSetting / 100) * (maxAngle - minAngle);

    marker.style.transform =
      `translateX(-50%) rotate(${angle}deg)`;
  }

  let draggingGrinder = false;

grinderDial.addEventListener("pointerdown", function (event) {
  if (shotRunning) return;

  draggingGrinder = true;
  grinderDial.setPointerCapture(event.pointerId);

  moveGrinder(event);
});

grinderDial.addEventListener("pointermove", function (event) {
  if (!draggingGrinder || shotRunning) return;

  moveGrinder(event);
});

grinderDial.addEventListener("pointerup", function () {
  draggingGrinder = false;
});

grinderDial.addEventListener("pointercancel", function () {
  draggingGrinder = false;
});

function moveGrinder(event) {
  const rect = grinderDial.getBoundingClientRect();

  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;

  const x = event.clientX - centerX;
  const y = event.clientY - centerY;

  let angle =
    Math.atan2(y, x) * (180 / Math.PI) + 90;

  if (angle > 180) {
    angle -= 360;
  }

  // Our grinder can rotate from -130° to +130°
  angle = Math.max(-130, Math.min(130, angle));

  grinderSetting =
    ((angle + 130) / 260) * 100;

  updateGrinder();
}

  function getTargetMiddle() {
    return (targetMin + targetMax) / 2;
  }

  function getFlowRate() {
    const idealTime = getTargetMiddle();

    const idealFlowRate = 36 / idealTime;

    const difference =
      grinderSetting - idealGrinderSetting;

    const flowRate =
      idealFlowRate + difference * 0.04;

    return Math.max(0.3, flowRate);
  }

  function updateShot() {
    if (!shotRunning) return;

    const now = performance.now();

    currentTime =
      (now - shotStartTime) / 1000;

    const flowRate = getFlowRate();

    currentWeight =
      currentTime * flowRate;

    timeDisplay.textContent =
      currentTime.toFixed(1) + " s";

    weightDisplay.textContent =
      currentWeight.toFixed(1) + " g";

    scaleDisplay.textContent =
      currentWeight.toFixed(1) + " g";

    const fillPercent =
      Math.min((currentWeight / 36) * 80, 100);

    espressoLiquid.style.height =
      fillPercent + "%";

    animationFrame =
      requestAnimationFrame(updateShot);
  }

  startButton.addEventListener("click", function () {
    if (shotRunning) return;

    shotRunning = true;

    currentTime = 0;
    currentWeight = 0;

    timeDisplay.textContent = "0.0 s";
    weightDisplay.textContent = "0.0 g";

    shotStartTime = performance.now();

    startButton.disabled = true;
    stopButton.disabled = false;

    espressoStream.style.height = "70px";
    espressoLiquid.style.height = "0%";
    scaleDisplay.textContent = "0.0 g";

    animationFrame =
      requestAnimationFrame(updateShot);
  });

  stopButton.addEventListener("click", function () {
    if (!shotRunning) return;

    attempts++;

    attemptDisplay.textContent =
    "Attempt " + attempts;

    shotRunning = false;

    cancelAnimationFrame(animationFrame);

    startButton.disabled = false;
    stopButton.disabled = true;

    espressoStream.style.height = "0";

    lastShotDisplay.textContent =
      currentWeight.toFixed(1) +
      " g in " +
      currentTime.toFixed(1) +
      " s";
    
    const weightDifference = Math.abs(currentWeight - 36);

    if (weightDifference > 1.5) {
    lastShotDisplay.textContent =
        currentWeight.toFixed(1) +
        " g in " +
        currentTime.toFixed(1) +
        " s — Stop closer to 36 g";
    } else if (
    currentTime >= targetMin &&
    currentTime <= targetMax
    ) {
    lastShotDisplay.textContent =
        currentWeight.toFixed(1) +
        " g in " +
        currentTime.toFixed(1) +
        " s — Calibration successful ✓";
    } else {
    lastShotDisplay.textContent =
        currentWeight.toFixed(1) +
        " g in " +
        currentTime.toFixed(1) +
        " s — Not calibrated yet";
    }
  });

  targetButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      targetMin =
        Number(button.dataset.min);

      targetMax =
        Number(button.dataset.max);

      targetButtons.forEach(function (btn) {
        btn.classList.remove("active");
      });

      button.classList.add("active");
    });
  });

  newCalibrationButton.addEventListener(
    "click",
    function () {
      idealGrinderSetting =
        randomNumber(33, 67);

      grinderSetting =
        randomNumber(33, 67);

      currentTime = 0;
      currentWeight = 0;

      timeDisplay.textContent = "0.0 s";
      weightDisplay.textContent = "0.0 g";
      lastShotDisplay.textContent =
        "No shot yet";

      attempts = 0;
      attemptDisplay.textContent = "Attempt 0";

      updateGrinder();
    }
  );

  // Initial state
  stopButton.disabled = true;

  updateGrinder();
});